/**
 * Recursively extracts only leaf field paths from a Yup schema.
 */
function getYupLeafFieldPaths(schema, prefix = '') {
  if (!schema?.fields) return [];

  return Object.entries(schema.fields).flatMap(([key, value]) => {
    const path = prefix ? `${prefix}.${key}` : key;

    if (value.type === 'object' && value.fields) {
      // Dive deeper, don't include the object itself
      return getYupLeafFieldPaths(value, path);
    }

    return [path];
  });
}

export default getYupLeafFieldPaths;
